import { useEffect, useState, useContext, useMemo } from "react";
import "./header.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../authentication/authHelpers";
import NotificationsModal from "./components/NotificationsModal";
import { useUserSession } from "../../hooks/useUserSession";
import { API } from "../../helpers/API/amplifyApi";
import { NotifContext } from "../dashboard/components/notifications/context/notifContext";
import RequestsDrawer from "./components/RequestsDrawer";
import { useSelector } from "react-redux";
import axios from "axios";
import { useMediaQuery } from "react-responsive";
import dayjsTZ from "../../utils/dayjs";
import MobileHeader from "./components/MobileHeader";
import KonfigurimetHeader from "./components/KonfigurimetHeader";
import KryefaqjaHeader from "./components/KryefaqjaHeader";
import ProblemsDrawer from "./components/ProblemsDrawer";
import InterviewDrawer from "./components/InterviewDrawer";
import { driveApi } from "../DriveRequest";
import { fetchData } from "../../fetchData";
import { apiRoutes } from "../../apiRoutes";
import { notificationUserToAdmin } from "../../utils/sendNotification";
import { callGmailAPI } from "../../utils";
import { updateAutomationControllerField } from "./components/saveNewCandidate";
import { requestDataWithParams } from "../../helpers/API/RequestFactory";
import { eventTracker } from "../../utils/eventTracker";
import useOpenOnce from "../../hooks/useOpenOnce";
import PersonalInfoConfirmationModal from "./components/PersonalInfoConfirmationModal/PersonalInfoConfirmationModal";
import Organigrama from "./components/Organigrama/Organigrama";
import HappyBirthdayModal from "./components/HappyBirthdayModal";
import ContactsModal from "./components/Contacts/ContactsModal";
import { QOTD_FIELD_ID } from "../../constantsFactory/quoteOfTheDay";
import HappyHolidaysModal from "../../assets/holidays/Modals/HappyHolidaysModal";
import { useSeasonalTheme } from "../../utils/seasonalTheme";
import { useBrowserPushPermission } from "../../hooks/useBrowserPushPermission";
import EnableBrowserPushModal from "./components/EnableBrowserPushModal";
import BrowserPushToggle from "./components/BrowserPushToggle";

const weatherId = "788ae94b-c7e9-4309-a79e-eacc8b279a62";
// get weather data form free api for new yourk and tirana
const TiranaUrl = `https://api.openweathermap.org/data/2.5/weather?q=tirana&units=imperial&appid=adaf1809160dd551dd81d02077f56678`;
const NewYorkUrl = `https://api.openweathermap.org/data/2.5/weather?q=new%20york&units=imperial&appid=adaf1809160dd551dd81d02077f56678`;
const PristinaUrl = `https://api.openweathermap.org/data/2.5/weather?q=prishtina&units=imperial&appid=adaf1809160dd551dd81d02077f56678`;

function Header() {
  let location = useLocation();
  const auth = useAuth();
  let navigate = useNavigate();
  const userSession = useUserSession();
  const { active: seasonalTheme } = useSeasonalTheme();
  const browserPush = useBrowserPushPermission();

  const [openPersonalInfoOnce, setOpenPersonalInfoOnce] = useOpenOnce(
    "personalInfoConfirmationModal",
    "personalInfoConfirmationModal",
    2000,
    true
  );
  const [openHbdModalOnce, setOpenHbdModalOnce] = useOpenOnce(
    "happyBirthdayModal",
    "hbdModal",
    2000,
    true
  );

  const [openStats, setOpenStats] = useState(false);
  const [notifsActive, setNotifsActive] = useState(false);
  const [requestsActive, setRequestsActive] = useState(false);
  const [problemsActive, setProblemsActive] = useState(false);
  const [interviewActive, setInterviewActive] = useState(false);
  const [openContactsModal, setOpenContactsModal] = useState(false);

  const [count, setCount] = useState([]);
  const [pendingRequest, setPendingRequests] = useState([]);

  // * @EneaXharau - state dataWeather holds an object with keys tirana, newyork which has info from api
  const [dataWeather, setDataWeather] = useState({});
  const [toggle, setToggle] = useState(false);
  const [toggleTirana, setToggleTirana] = useState(false);
  const [togglePrishtina, setTogglePrishtinas] = useState(false);

  // get notifications with context
  const { candidates } = useSelector((state) => state.candidates);
  const { programFields } = useSelector((state) => state.programFields);
  const { notificationsArr, dispatch } = useContext(NotifContext);
  const { employeeRequests } = useSelector((state) => state.employeeRequests);
  const { problematikat } = useSelector((state) => state.problematikat);
  const { employees } = useSelector((state) => state.employeesList);
  const { accessToken } = useSelector((state) => state.accessToken);
  const { isDarkMode } = useSelector((state) => state.usersList);
  // const { departments } = useSelector((state) => state.departments);
  // const { hotCredentials } = useSelector((state) => state.hotCredentials);

  const driveRequest = driveApi({ accessToken });
  const [userPhoto, setUserPhoto] = useState("");

  const [qotd, setQotd] = useState({ quote: "", quoteEn: "", author: "" });

  const getImageFromDrive = async () => {
    const userSub = auth?.user?.userSub || "";
    const index = (employees || []).findIndex((el) => el?.userSub === userSub);

    if (index !== -1) {
      const fileId = employees?.[index]?.googleDriveFileId || "";

      if (!!fileId) {
        await driveRequest
          .getImageSrc(fileId)
          .then((image) => {
            setUserPhoto(image?.src);
          })
          .catch((err) => console.log("Error getImageSrc: ", err));
      }
    }
  };

  //region >handleLogOut()
  const handleLogOut = async () => {
    eventTracker("Header", "click", "Logged out");
    await userSession.close(auth?.user);
    await auth.signout(() => navigate("/login"));
  };
  //region HEADER DATA
  // load the notifications
  async function loadNotifications() {
    const idObj =
      auth?.userRole === "Employee"
        ? {
            filterKey: "userDetails",
            filterValue: auth?.user?.identityId,
          }
        : null;
    await requestDataWithParams("notifications", null, null, idObj).then(
      (notifs) =>
        dispatch({
          type: "LOAD_NOTIFS",
          payload: notifs.map((el) => ({
            ...el,
            identityId: auth?.user?.identityId,
            ...(el?.userDetails[auth?.user?.identityId] || {}),
          })),
        }),
      (err) => console.error("error loading notifs", err)
    );
  }

  /**
   * * @EneaXharau - Async function which fetches programFields/weatherid
   * * to get weather information and set it in state to re-render component
   */
  const fetchWeather = async () => {
    await API.get("programFields", `/programFields/${weatherId}`)
      .then((res) => {
        setDataWeather(res.fieldOptions);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // The quote is chosen once a day by the quoteOfTheDay cron and stored on this
  // record, so the header only reads it. It used to be fetched here from
  // quotable.io, which no longer exists.
  const fetchQotd = async () => {
    await API.get("programFields", `/programFields/${QOTD_FIELD_ID}`)
      .then((res) => {
        const option = res?.fieldOptions || {};
        if (!option?.quote) return;
        setQotd({
          quote: option.quote.toString(),
          quoteEn: option.quoteEn || "",
          author: option.author || "",
        });
      })
      .catch((e) => {
        console.log("Error loading quote of the day: ", e);
      });
  };

  /**
   * * @EneaXharau - Async function which fetches WeatherAPI with axios gets the JSON obj
   * * then it sets in state using API.put and then it re-fetches the info from said table
   */
  const updateWeather = async () => {
    let tiranaData = {};
    let newyorkData = {};
    let pristinaData = {};
    await axios.get(TiranaUrl).then((response) => {
      tiranaData = response.data;
    });
    await axios.get(NewYorkUrl).then((response) => {
      newyorkData = response.data;
    });
    await axios.get(PristinaUrl).then((response) => {
      pristinaData = response.data;
    });
    API.put("programFields", `/programFields/${weatherId}`, {
      body: {
        fieldOptions: {
          newyork: newyorkData,
          tirana: tiranaData,
          pristina: pristinaData,
        },
      },
    })
      .then(() => {
        fetchWeather();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  //region EXP DOCS & CALENDLY
  const { docsLastCheck = undefined } = useMemo(() => {
    let options = {};
    for (let i = 0; i < programFields?.length; i++) {
      const field = programFields[i];
      if (field?.fieldName === "Automation Controller") {
        options = field.fieldOptions;
      }
    }
    return options;
  }, [programFields]);

  const getExpiringDocs = async () => {
    let docs = [];
    const currentTimestamp = parseInt(dayjsTZ().format("x"));
    await fetchData(apiRoutes.documentation).then((res) => {
      const data = res.filter(
        (el) =>
          parseInt(el?.expirationDate) < currentTimestamp + 604800000 &&
          parseInt(el?.expirationDate) > currentTimestamp
      );
      docs = data;
    });
    return docs;
  };
  const fireExpiringDocsNotifs = async () => {
    (await getExpiringDocs())?.forEach((el) => {
      let currentEmployee = null;
      for (let i = 0; i < employees?.length; i++) {
        if (employees[i]?.employeeId === el?.recordId) {
          currentEmployee = employees[i];
          break;
        }
      }
      if (!!currentEmployee) {
        const notifBody = {
          notificationTitle: "Dokument në prag skadence",
          notificationBody: `Dokumenti "${el?.docType}" për punonjësin ${
            currentEmployee?.employeeFirstName
          } ${currentEmployee?.employeeLastName} skadon ${
            dayjsTZ(el?.expirationDate).date() === dayjsTZ().date()
              ? "sot"
              : `në ${dayjsTZ(el?.expirationDate).format("DD/MM/YYYY")}`
          }!`,
          notificationUrl: "/dokumentacione",
        };
        notificationUserToAdmin(notifBody, employees);
        callGmailAPI("sendEmail", {
          to: "developers@flex.al",
          subject: "Dokument ne prag skadence! ",
          body: `<p>Dokumenti "${el?.docType}" për punonjësin ${
            currentEmployee?.employeeFirstName
          } ${currentEmployee?.employeeLastName} skadon ${
            dayjsTZ(el?.expirationDate).date() === dayjsTZ().date()
              ? "sot"
              : `në ${dayjsTZ(el?.expirationDate).format("DD/MM/YYYY")}`
          }!</p>
            <br />
            <p>Për të parë dokumentin kliko <a href="https://portal.flex.al/dokumentacione">këtu</a></p>
            <p>Best Regards,</p>
            <p>Flex Team</p>`,
          attachments: [],
          category: "error",
          authData: false,
        })
          .then(() => {})
          .catch((err) => console.log(err));
      }
    });
    updateAutomationControllerField("docsLastCheck");
  };

  useEffect(() => {
    try {
      if (!!docsLastCheck) {
        if (dayjsTZ(docsLastCheck).valueOf() + 86400000 < Date.now()) {
          fireExpiringDocsNotifs();
        }
      } else {
        fireExpiringDocsNotifs();
      }
      //newCandidates
      // console.log((Date.now() - dayjsTZ(calendlyLastCheck).valueOf()) / 60000);
      // if (!!candidates && !!departments && !!programFields?.length) {
      //   const { fieldOptions: defaultPermissions } = programFields?.find(
      //     ({ fieldId }) => fieldId === INTERVIEW_DOCS_PERMISSION_LIST_FIELD_ID
      //   );
      //   if (!!calendlyLastCheck) {
      //     if (Date.now() - dayjsTZ(calendlyLastCheck).valueOf() > 3600000) {
      //       saveNewCandidate({
      //         candidates,
      //         departments,
      //         employees,
      //         driveRequest,
      //         hotCredentials,
      //         defaultPermissions,
      //       });
      //     }
      //   } else {
      //     saveNewCandidate({
      //       candidates,
      //       departments,
      //       employees,
      //       driveRequest,
      //       hotCredentials,
      //       defaultPermissions,
      //     });
      //   }
      // }
    } catch (error) {
      console.error("ERROR NGA Header.js", error);
    }
  }, [docsLastCheck]); // + calendlyLastCheck

  // calculate from ferenight to celcius
  const fToCelTirana = ((dataWeather?.tirana?.main?.temp - 32) * 5) / 9;
  const fToCel = ((dataWeather?.newyork?.main?.temp - 32) * 5) / 9;
  const fToCelPristina = ((dataWeather?.pristina?.main?.temp - 32) * 5) / 9;

  // * @EneaXharau - limit the fetches done to the api for every 10 minutes
  // * and between 1PM to 10PM
  useEffect(() => {
    if (!!Object.keys(auth?.user || {}).length) {
      try {
        updateWeather();
        fetchWeather();
        fetchQotd();
        getImageFromDrive();
        const time = new Date().getHours();
        if (time >= 13 || time <= 22) {
          const interval = setInterval(() => {
            updateWeather();
          }, 600000);
          return () => clearInterval(interval);
        }
      } catch (error) {
        console.error("ERROR NGA Header.js", error);
      }
    }
  }, [auth, employees]);

  useEffect(() => {
    if (!!auth?.user?.identityId) {
      loadNotifications();
    }
    if (!!auth?.employee?.employeeDayOfBirth) {
      if (
        dayjsTZ().format("DD/MM") !==
        dayjsTZ(auth.employee.employeeDayOfBirth).format("DD/MM")
      ) {
        localStorage.removeItem("hbdModal");
      }
    }
  }, [auth?.user?.identityId]);

  useEffect(() => {
    setCount(notificationsArr.filter((x) => !x?.notificationMarkedRed));
  }, [notificationsArr]);

  useEffect(() => {
    if (!!employeeRequests) {
      //Vendos numrin e kerkesave qe jane Pending te Badge i kerkesave per leje
      setPendingRequests(
        employeeRequests
          ?.map((el) => ({
            ...el,
            requestStatus:
              el?.requestPeriod?.length > 1
                ? dayjsTZ().valueOf() - el?.requestPeriod?.slice(-1) > 0
                  ? "Përfunduar"
                  : el.requestStatus
                : dayjsTZ().valueOf() - el.requestPeriod[0] > 0
                ? "Përfunduar"
                : el.requestStatus,
          }))
          ?.filter?.(
            (pr) =>
              pr?.requestStatus === "Pending" && pr?.userSub !== "undefined"
          )
      );
    }
  }, [employeeRequests]);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 460px)",
  });

  const openPersonalInfoOnceModal =
    !!auth?.employee &&
    !auth.employee.hasOwnProperty("dataVerification") &&
    !!openPersonalInfoOnce;
  const shouldOpenHbdModalOnce = !!auth?.employee?.employeeDayOfBirth
    ? dayjsTZ().format("DD/MM") ===
        dayjsTZ(auth.employee.employeeDayOfBirth).format("DD/MM") &&
      openHbdModalOnce
    : false;

  //region RETURN
  return (
    <>
      {isDesktopOrLaptop ? (
        <div className={`header-app ${isDarkMode ? "dark" : ""}`}>
          {/* winter */}
          {/* {new Array(50).fill(<div className="snowflake" />).map((el) => el)} */}
          {location.pathname.startsWith("/konfigurimet") === true ? (
            <KonfigurimetHeader handleLogOut={handleLogOut} />
          ) : (
            <KryefaqjaHeader
              {...{
                qotd,
                location,
                dataWeather,
                fToCelTirana,
                setToggleTirana,
                togglePrishtina,
                fToCelPristina,
                setTogglePrishtinas,
                setOpenStats,
                setOpenContactsModal,
                toggleTirana,
                fToCel,
                setToggle,
                toggle,
                userPhoto,
                setRequestsActive,
                requestsActive,
                pendingRequest,
                setNotifsActive,
                notifsActive,
                handleLogOut,
                count,
                setQotd,
                setProblemsActive,
                problemsActive,
                problematikatCount: problematikat?.filter(
                  (x) => x?.ticketStatus && x.ticketStatus !== "Completed"
                )?.length,
                candidatesCount: candidates.filter(
                  (items) =>
                    dayjsTZ(items.applicantInterviewDate).week() ===
                    dayjsTZ().week()
                )?.length,
                interviewActive,
                setInterviewActive,
                browserPushToggle: (
                  <BrowserPushToggle
                    permission={browserPush.permission}
                    supported={browserPush.supported}
                    onEnable={browserPush.requestPermission}
                    onOpenForceModal={() => browserPush.setForceOpen(true)}
                    onRefresh={browserPush.refresh}
                  />
                ),
              }}
            />
          )}
        </div>
      ) : (
        <MobileHeader
          {...{
            location,
            handleLogOut,
            setRequestsActive,
            requestsActive,
            pendingRequest,
            setNotifsActive,
            notifsActive,
            setOpenContactsModal,
            count,
            setOpenStats,
            userPhoto,
            setProblemsActive,
            problemsActive,
            problematikatCount: problematikat?.filter(
              (x) => x?.ticketStatus && x.ticketStatus !== "Completed"
            )?.length,
            candidatesCount: candidates.filter(
              (items) =>
                dayjsTZ(items.applicantInterviewDate).week() ===
                dayjsTZ().week()
            )?.length,
            interviewActive,
            setInterviewActive,
            browserPushToggle: (
              <BrowserPushToggle
                permission={browserPush.permission}
                supported={browserPush.supported}
                onEnable={browserPush.requestPermission}
                onOpenForceModal={() => browserPush.setForceOpen(true)}
                onRefresh={browserPush.refresh}
              />
            ),
          }}
        />
      )}
      <EnableBrowserPushModal
        open={browserPush.forceOpen}
        permission={browserPush.permission}
        supported={browserPush.supported}
        onEnable={browserPush.requestPermission}
        onCloseWhenGranted={() => browserPush.setForceOpen(false)}
        onDismiss={browserPush.dismissForNow}
      />
      <NotificationsModal {...{ notifsActive, setNotifsActive }} />
      <RequestsDrawer {...{ requestsActive, setRequestsActive }} />
      <ProblemsDrawer {...{ problemsActive, setProblemsActive }} />
      <InterviewDrawer {...{ interviewActive, setInterviewActive }} />
      {openStats ? (
        <Organigrama open={openStats} setOpen={setOpenStats} />
      ) : null}
      {openPersonalInfoOnceModal ? (
        <PersonalInfoConfirmationModal
          open={openPersonalInfoOnceModal}
          setOpen={setOpenPersonalInfoOnce}
        />
      ) : null}
      {shouldOpenHbdModalOnce ? (
        <HappyBirthdayModal
          open={shouldOpenHbdModalOnce}
          setOpen={setOpenHbdModalOnce}
        />
      ) : null}
      {openContactsModal ? (
        <ContactsModal
          open={openContactsModal}
          setOpen={setOpenContactsModal}
        />
      ) : null}
      {seasonalTheme?.effects?.modal ? (
        <HappyHolidaysModal
          themeId={seasonalTheme.id}
          enabled={!!seasonalTheme}
        />
      ) : null}
    </>
  );
}
export default Header;
